import styled from "styled-components";

const Link1 = styled.p`
  color: #ffffff;
  font-weight: 500;
  font-size: 15px;
  margin: auto;
  :hover, &.active {
        color: #9701fc;
      }
`

export default Link1
